<template>
  <div class="newcomer-container">
    <div class="newcomer-box">
      <div class="newcomer-msg">
        <div>
          <!-- <p class="blod2">新人专享</p> -->
          <p class="blod3">0元专区</p>
          <p class="blod4">新人前{{ getNewPersonFreeOrderCount }}单</p>
          <p class="blod4">全场1张免单卡</p>
        </div>
        <button class="btn" @click="goNewcomerPage">立即兑换</button>
      </div>
      <div class="newcomer-list" v-if="dataList.length > 0">
        <div class="block" v-for="(item, index) in dataList.slice(0, 2)" :key="index" @click="entoGoodsDetail(item.ProductID)">
          <div class="newcomer-list-item">
            <!-- <span class="nc-tag">为你推荐</span> -->
            <div class="nc-img"><img v-lazy="item.PicUrl" alt="" /></div>
            <p class="nc-title">{{ item.TitleShort }}</p>
            <div class="nc-price">
              <span>￥</span>0<span class="t_999">￥{{ item.ProductPrice }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    dataList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapGetters(['getNewPersonFreeOrderCount'])
  },
  methods: {
    goNewcomerPage() {
      this.$router.push({ name: 'newcomer' })
    },
    entoGoodsDetail(productID) {
      this.$router.push({
        name: 'goodsDetail',
        query: {
          productID: productID,
          isFreeCard: true
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.newcomer-container {
  margin-bottom: 10px;
  padding: 0 6px;
  box-sizing: border-box;
}
.newcomer-box {
  display: flex;
  justify-content: space-between;
  height: 42vw;
  padding: 2vw 3.8vw;
  box-sizing: border-box;
  border-radius: 7px;
  overflow: hidden;
  background: url('http://youp-read.leqilucky.com/upaiyun/Sys/20200623/5335372925865982694.jpeg') no-repeat;
  background-size: 100% auto;
  background-position: center center;
}
.newcomer-msg {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding-top: 2vw;
  color: #ffffff;
  flex-shrink: 0;
}
.newcomer-msg .blod2 {
  font-size: 5vw;
  font-weight: 700;
}
.newcomer-msg .blod3 {
  font-size: 7.5vw;
  font-weight: 700;
  margin-bottom: 0.4vh;
}
.newcomer-msg .blod4 {
  margin-left: 2px;
}
.newcomer-msg .btn {
  height: 32px;
  width: 92px;
  align-self: flex-start;
  border-radius: 35px;
  color: #ff0101;
  background: linear-gradient(to bottom, #f8f8b2, #f8f861);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  margin-bottom: 2px;
}
.newcomer-list {
  display: flex;
}
.newcomer-list {
  .block {
    display: flex;
    width: 26vw;
    overflow: hidden;
    border-radius: 5px;
    margin-right: 3vw;
    &:last-child {
      margin-right: 0;
    }
  }
}
.newcomer-list-item {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  font-size: 13px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
.newcomer-list-item:last-child {
  margin-right: 0;
}
.newcomer-list-item .nc-tag {
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  padding: 2px 4px;
  background: #22b9a4;
  color: #ffffff;
  font-size: 10px;
  border-bottom-right-radius: 5px;
}
.newcomer-list-item .nc-img {
  width: 100%;
  height: 26vw;
}
.newcomer-list-item .nc-img img {
  display: block;
  height: 100%;
  width: 100%;
  background: #f5f5f5;
}
.newcomer-list-item .nc-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding: 1vw;
  box-sizing: border-box;
}
.newcomer-list-item .nc-price {
  color: #ff0101;
  font-size: 16px;
  padding: 1vw;
  box-sizing: border-box;
}
.newcomer-list-item .nc-price .t_999 {
  text-decoration: line-through;
  margin-left: 5px;
}
.newcomer-list-item .nc-price span {
  font-size: 10px;
}
</style>
